var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"align-middle"},[_vm._v(_vm._s(_vm.channel))]),(_vm.displayPill)?_c('b-badge',{staticClass:"badge-outlined ml-1",attrs:{"pill":"","variant":_vm.isChannelConfigured ? 'success' : 'danger'}},[_vm._v(" "+_vm._s(_vm.isChannelConfigured ? _vm.$t('analyserConfigured') : _vm.$t('analyserNotConfigured'))+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }